import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-2 text-zinc-400 hover:text-white mb-6"
  >
    <ArrowLeft className="w-4 h-4" /> Back
  </button>
);
